import { useMemo } from 'react'
import { useContext } from 'react'

import { NavigatorContext } from 'src/context/navigatorContext'
import SimulationCtx from 'src/context/simulationCtx'
import { cn } from 'src/utils/cn'

import HeaderBanner from './HeaderBanner'
import cls from './PageContentWrapper.module.scss'
import ReloadBuildBanner from './ReloadBuildBanner'

const PageContentWrapper = ({ isSmallScreen, shouldReload, children }) => {
    const { sidebarCollapsed } = useContext(NavigatorContext)
    const { isEnabled: isSimulationEnabled } = useContext(SimulationCtx)

    const className = useMemo(() => {
        if (isSmallScreen) {
            return cls['small-screen']
        }

        if (sidebarCollapsed) {
            return `${cls['sidebar-collapsed']}  ${cls['sidebar-margin-top']}`
        }

        return `${cls['sidebar-open']}  ${cls['sidebar-margin-top']}`
    }, [isSmallScreen, sidebarCollapsed])

    return (
        <div
            data-simulation-enabled={isSimulationEnabled}
            className={className}
        >
            <div
                className={cn(
                    'child h-full w-full',
                    isSimulationEnabled && 'mt-4'
                )}
            >
                <HeaderBanner />
                {shouldReload ? <ReloadBuildBanner /> : null}
                {children}
            </div>
        </div>
    )
}

export default PageContentWrapper
